import React from 'react';
import { MapPin, Navigation, Info } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { PublicLayout } from '../../components/layout/PublicLayout';

import { BackButton } from '../../components/ui/BackButton';

export const VenueMapPage: React.FC = () => {
    return (
        <PublicLayout>
            <div className="min-h-screen bg-[#0A0A0A] pt-24 pb-12 px-4 md:px-8">
                <div className="max-w-6xl mx-auto space-y-12">
                    {/* Header */}
                    <div className="text-center space-y-4 relative">
                        <div className="absolute left-0 top-0">
                            <BackButton />
                        </div>
                        <h1 className="text-5xl md:text-6xl font-display font-bold text-white tracking-tight">
                            Venue <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF991C] to-[#7C4DFF]">Map</span>
                        </h1>
                        <p className="text-xl text-white/60 max-w-2xl mx-auto">
                            Navigate your way through the ENIGMA 2026 campus.
                        </p>
                    </div>

                    <Card className="p-4 bg-white/[0.03] border border-white/[0.08] rounded-2xl backdrop-blur-xl overflow-hidden">
                        <div className="aspect-video w-full bg-white/5 rounded-xl relative flex items-center justify-center overflow-hidden group">
                            {/* Placeholder for Map Image */}
                            <div className="absolute inset-0 bg-gradient-to-br from-[#FF991C]/10 to-[#311b92]/10 opacity-50"></div>
                            <div className="text-center p-8 relative z-10">
                                <MapPin className="w-16 h-16 text-[#FF991C] mx-auto mb-4 animate-bounce" />
                                <h3 className="text-2xl font-bold text-white mb-2">Interactive Map Coming Soon</h3>
                                <p className="text-white/60 max-w-md mx-auto">
                                    We are finalizing the venue layout. A detailed map will be available here shortly.
                                </p>
                            </div>

                            {/* Grid overlay effect */}
                            <div className="absolute inset-0 bg-cyber-grid opacity-[0.03] pointer-events-none"></div>
                        </div>
                    </Card>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <Card className="p-6 bg-white/[0.03] border border-white/[0.08] rounded-2xl backdrop-blur-xl">
                            <div className="flex items-start gap-4">
                                <div className="p-3 rounded-xl bg-[#7C4DFF]/10 text-[#7C4DFF]">
                                    <MapPin className="w-6 h-6" />
                                </div>
                                <div>
                                    <h3 className="text-lg font-bold text-white mb-2">Location</h3>
                                    <p className="text-white/60 text-sm">
                                        Seth M.R. Jaipuria School,<br />
                                        Goel Campus, Lucknow
                                    </p>
                                    <Button
                                        variant="outline"
                                        size="sm"
                                        className="mt-4 w-full border-[#FF991C]/30 text-[#FF991C] hover:bg-[#FF991C]/10"
                                        onClick={() => window.open('https://maps.google.com', '_blank')}
                                    >
                                        <Navigation className="w-4 h-4 mr-2" />
                                        Get Directions
                                    </Button>
                                </div>
                            </div>
                        </Card>

                        <Card className="p-6 bg-white/[0.03] border border-white/[0.08] rounded-2xl backdrop-blur-xl">
                            <div className="flex items-start gap-4">
                                <div className="p-3 rounded-xl bg-[#FF991C]/10 text-[#FF991C]">
                                    <Info className="w-6 h-6" />
                                </div>
                                <div>
                                    <h3 className="text-lg font-bold text-white mb-2">Help Desk</h3>
                                    <p className="text-white/60 text-sm">
                                        Located at the main entrance.<br />
                                        Open from 8:00 AM to 5:00 PM.
                                    </p>
                                </div>
                            </div>
                        </Card>

                        <Card className="p-6 bg-white/[0.03] border border-white/[0.08] rounded-2xl backdrop-blur-xl">
                            <div className="flex items-start gap-4">
                                <div className="p-3 rounded-xl bg-amber-500/10 text-amber-400">
                                    <Info className="w-6 h-6" />
                                </div>
                                <div>
                                    <h3 className="text-lg font-bold text-white mb-2">Parking</h3>
                                    <p className="text-white/60 text-sm">
                                        Designated parking available for school buses and guest vehicles near Gate 2.
                                    </p>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </PublicLayout>
    );
};
